var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('adaptive-charts-layout',{attrs:{"left":_vm.userProfileComponent,"chartUserId":_vm.userId,"chartOrganizationId":_vm.organizationId}})}
var staticRenderFns = []

export { render, staticRenderFns }